import React, { useState, useEffect } from 'react';
import { fetchUserDetails } from '../../../../api/userApi';
import authService from '../../../../services/authService';
import { FaUserCircle } from 'react-icons/fa';
import './UserProfile.css';

import { APP_VERSION } from '../../../../AppVersion/version';

const Profile = () => {
  const [userData, setUserData] = useState({
    userName: 'N/A',
    email: 'N/A',
    mobileNo: 'N/A',
    userId: 'N/A',
    isActive: true,
    userRole: 0
  });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.title = 'Profile - Finhaat Gurukul';

    const fetchUserData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const userId = authService.getUserId();
        // console.log('Fetching user details for userId:', userId);

        if (!userId) {
          throw new Error('No user ID (email) found');
        }

        const response = await fetchUserDetails(userId);
        // console.log('API response:', response);
        const { data } = response;
        setUserData({
          userName: data?.userName || 'N/A',
          email: data?.email || authService.getUserEmail() || 'N/A',
          mobileNo: data?.mobileNo || 'N/A',
          userId: data?.userId || data?.userMasterId || 'N/A',
          isActive: data?.isActive === 1,
          userRole: data?.userRole
        });
      } catch (error) {
        // console.error('Error fetching user details:', error);
        setError('Failed to fetch user details. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);

  if (isLoading) {
    return <div className="spinner-container-user-profile">
      <div className="spinner-user-profile"></div>
    </div>
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="profile-container">
      <div className="version-tag">v{APP_VERSION}</div>
      <div className="student-profile">
        <div className="profile-header">
          <FaUserCircle className="profile-icon" />
          <h1 className="student-name">{userData.userName}</h1>
          <p className="student-contact">
            <span>Email: {userData.email}</span>
            <span>Phone: {userData.mobileNo}</span>
          </p>
        </div>
        <div className="profile-details">
          <p><strong>User ID:</strong> {userData.userId}</p>
          <hr className="hr-profile" />
          <p><strong>Account:</strong> {userData.isActive ? 'Active' : 'Inactive'}</p>
          <hr className="hr-profile" />
          <p><strong>Role:</strong> {userData.userRole === 0 ? 'User' : 'Admin'}</p>
        </div>
      </div>
    </div>
  );
};

export default Profile;
